export function ExtractedFrames({ images }) {
  if (!images || !Array.isArray(images) || images.length === 0) return null;

  return (
    <div className="mb-8">
      <h3 className="text-sm font-bold text-slate-400 uppercase tracking-wide mb-3">
        Your Swing Photos
      </h3>
      <div className={`grid gap-3 ${
        images.length === 1 ? 'grid-cols-1 max-w-sm mx-auto' :
        images.length <= 4 ? 'grid-cols-2' :
        'grid-cols-3 sm:grid-cols-4'
      }`}>
        {images.map((src, i) => (
          <div key={i} className="bg-white/5 border border-white/10 rounded-xl overflow-hidden">
            <img
              src={src}
              alt={`Frame ${i + 1}`}
              className="w-full aspect-[4/3] object-cover"
            />
            <p className="text-[11px] text-slate-400 text-center py-1.5 font-medium">
              Frame {i + 1}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
